import { AddressActionKeys as keys } from './addressActionKeys';
import * as types from './addressActionTypes';
import { IAddress } from './addressInterfaces';

export const addressActionCreators = {
  setAddresses: (addresses: IAddress[]): types.SetAddressses => ({ payload: addresses, type: keys.SET_ADDRESSES }),

  toggleSaving: (addressId: number): types.ToggleAddressSaving => ({
    payload: { addressId },
    type: keys.TOGGLE_ADDRESS_SAVING
  }),
  updateAddressFromAxAddress: (payload: { addressId: number; axRecId: number }): types.UpdateAddressFromAxAddress => ({
    payload,
    type: keys.UPDATE_ADDRESS_FROM_AX_ADDRESS
  })
};
